module.exports = __webpack_public_path__ + "static/media/HomeLoan.55d56b77.png";